/* eslint-disable arrow-body-style */
import PropTypes from 'prop-types';
import { Box, Tooltip, Zoom, IconButton } from '@mui/material';
import { AssignUserAvatar } from 'src/components/custom-avatar';
import { Iconify } from 'src/components';
import { assignCountBoxStyle } from '../../../../styles/NewLead';

const AssigneeField = ({ rowData, getAssignees, whatsappView }) => {
    return (
        <>
            {rowData?.assignees?.length > 0 ? (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Tooltip
                        title={getAssignees(rowData)}
                        placement="bottom"
                        TransitionComponent={Zoom}
                        TransitionProps={{ timeout: 300 }}
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <AssignUserAvatar
                                sx={{ cursor: 'pointer', mr: 1, bgcolor: '#919EAB3D', width: 28, height: 28, fontSize: '0.75rem', ...(whatsappView ? { width: "1.8rem", height: "1.8rem", fontSize: "0.7rem", mr: "0" } : {}) }}
                                src={rowData?.assignees?.[0]?.user?.avatar || ''}
                                name={`${rowData?.assignees?.[0]?.user?.first_name || ''} ${rowData?.assignees?.[0]?.user?.last_name || ''}`}
                                role={rowData?.assignees?.[0]?.role}
                            />
                            {rowData?.assignees?.length > 1 && <Box sx={assignCountBoxStyle}>+ {rowData?.assignees?.length - 1}</Box>}
                        </Box>
                    </Tooltip>
                </Box>
            ) : (
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <IconButton
                        aria-label="upload picture"
                        component="label"
                        disabled={rowData?.is_archive_pending}
                        sx={{ p: 0, '&:hover': { bgcolor: 'transparent' }, ...(whatsappView ? { padding: 0 } : {}) }}
                    >
                        <Iconify
                            icon={whatsappView ? "gala:add" : "material-symbols:add-circle"}
                            style={{ color: whatsappView ? '#075e54' : 'rgba(145, 158, 171, 0.5)' }}
                            sx={{ mr: '0' }}
                            width={16}
                            height={16}
                        />
                    </IconButton>
                </Box>
            )}
        </>
    );
};

AssigneeField.propTypes = {
    rowData: PropTypes.any,
    getAssignees: PropTypes.any,
    whatsappView: PropTypes.bool
};

export default AssigneeField;